import {FormStatus, PaginatedSearch, UserRowData} from "./shared";

export interface SearchOrgUnitMachineQuery extends PaginatedSearch {
    organizationUnitId: number
}

export interface SearchOrgMachinesQuery extends PaginatedSearch {
    organizationId: number | undefined
}

export interface UpdateMachineTags {
    organizationUnitId: number,
    machineId: string,
    tagId: string,
    tags: Tag[]
}

export interface ServerTag {
    Key: string,
    Value: string
}

export interface Tag {
    key: string,
    value: string
}

export interface Machine {
    id: string,
    customerId: number,
    organizationId: number,
    organizationName: string,
    tagId?: number,
    name: string,
    friendlyName: string,
    email: string,
    tags: MachineTag[],
    organizationUnitName: string,
    organizationUnitId: number,
    isActive?: boolean,
    isExpired?: boolean,
    version?: string,
    label?: string;
}

export interface MachineTag {
    key: string,
    value: string
}

export type ContactToAdd = UserRowData;

export type Error = string;

export interface ContactError{
    [fieldName: string]: Error
}

export interface MachineContactModel {
    id: number | string,
    data: ContactToAdd,
    errors: ContactError,
    errorMessage?: string,
    status: FormStatus,
}

export const isSelectedItem = (f: MachineContactModel) => (typeof f.id === 'string');
export const isImportedItem = (f: MachineContactModel) => typeof f.id === 'number';
export const isEmptyImportedItem = (f: MachineContactModel): boolean => (typeof f.id === 'number') && !!f.data && !f.data.email && !f.data.firstName && !f.data.lastName;
